import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, take, tap } from 'rxjs';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { UsersService } from '../providers/api/users.service';
import { User } from '../models/api/user';


@Injectable({ providedIn: 'root' })
export class UserService {
  public users: User[] = [];
  public usersObject: { [id: string]: User } = {};

  public users$: ReplaySubject<User[]> = new ReplaySubject<User[]>(0);
  public usersObject$: ReplaySubject<{ [id: string]: User }> = new ReplaySubject<{ [id: string]: User }>(0);

  private _userOb: User;
  private _user: ReplaySubject<User> = new ReplaySubject<User>(0);

  /**
   * Constructor
   */
  constructor(
    private firestore$: AngularFirestore,
    private auth$: AngularFireAuth,
    private userApi$: UsersService
  ) {
  }


  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  get user$(): Observable<User> {
    return this._user.asObservable();
  }

  get user(): User {
    return this._userOb;
  }

  set user(value: User) {
    // Store the value
    this._userOb = value;
    this._user.next(value);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  getAll(): Observable<User[]> {
    return this.userApi$.usersControllerFindAll()
      .pipe(
        tap((users) => {
          const obUsers = {};
          users = users
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(fe => {
              obUsers[fe.id] = fe;
              return fe;
            });
          this.usersObject = obUsers;
          this.users = users;
          this.usersObject$.next(obUsers);
          this.users$.next(users);
        })
      ).pipe(take(1));
  }

  getUser(): Observable<any> {
    return new Observable<any>((subscriber) => {
      this.auth$.user.pipe(take(1)).subscribe(async (authUser) => {
        // console.log(authUser);
        if (authUser) {
          let user: User = {
            id: authUser?.uid,
            email: authUser.email,
            avatar: authUser.photoURL,
            name: authUser.displayName,
            isAdmin: false,
            isEnable: true
          };
          this.getAll().subscribe(async () => {
            if (!this.usersObject[authUser.uid]) {
              await this.firestore$.collection('users').doc(authUser?.uid).set(user);
            } else {
              user = {
                ...this.usersObject[authUser.uid],
                email: authUser.email,
                avatar: authUser.photoURL,
                name: authUser.displayName
              };

              // await this.firestore$.doc('users/' + authUser?.uid).update(this.usersObject[authUser.uid]);
            }

            this.user = { ...user };

            subscriber.next(true);
            subscriber.complete();
          });
        } else {
          subscriber.next(false);
          subscriber.complete();
        }
      });
    });
  }

  /**
   * Update the user
   *
   * @param user
   */
  update(user: User): Observable<any> {
    return new Observable<any>((subscriber) => {
      this.firestore$.doc('users/' + user.id).update(user)
        .then(() => {
          subscriber.next();
          subscriber.complete();
        })
        .catch(() => {
          subscriber.error();
        });
    });
  }
}
